import React, { Component, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import FirstModal from './FirstModal';
import PrizeItem from './PrizeItem';
import HTTP from '../../script/service';

class FirstRechargeSuccess extends Component {
  state = {
    visible: false,
    prizeList: [],
  };

  // 展示弹窗
  showModal = (orderId) => {
    // IN20211110185810165JRFEQ
    this.getUserIsFirstRecharge(orderId);
  };

  // 查询用户是否满足首充活动
  getUserIsFirstRecharge = (orderId) => {
    const { base } = this.props;
    HTTP._get_user_is_first_recharge({ uid: base.uid, orderId }).then((res) => {
      if (res && res.code === 200 && !!res.data.isFirstRecharge) {
        const { activityItems } = res.data;
        let prizeList = [];
        activityItems.forEach((item) => {
          item.items.forEach((_item) => {
            prizeList.push(_item);
          });
        });
        this.setState({
          visible: true,
          prizeList,
        });
      }
    });
  };

  // 关闭弹窗
  closeModal = () => {
    if (this.props.closeModal) {
      this.props.closeModal();
    }
    this.setState({ visible: false, prizeList: [] });
  };

  // 打开我的钱包
  showMyCenter = () => {
    this.closeModal();
    // 关闭父级弹窗
    if (this.props.closeModal) {
      this.props.closeModal();
    }
    this.props.showMyCenter && this.props.showMyCenter('tab6');
  };

  render() {
    const { visible, prizeList } = this.state;
    return (
      <FirstModal
        visible={visible}
        className="first-charge-success"
        onCancel={this.closeModal}
        footer={
          <Fragment>
            {/* 充值按钮 */}
            <div className="btn-look-bag" onClick={this.showMyCenter} />
          </Fragment>
        }
      >
        <div className="charge-content">
          <Scrollbar
            className="first-change-scroll"
            ref={(ele) => (this.firstChangeScrollEle = ele)}
          >
            <ul className="content-list">
              {prizeList && prizeList.length
                ? prizeList.map((item, index) => (
                    <PrizeItem key={index} item={item} />
                  ))
                : null}
            </ul>
            <div className="foot-text">
              <p>礼物已放入房间背包中，礼物优惠券可在送</p>
              <p>礼物时享受优惠价。装扮已自动佩戴成功，</p>
              <p>可去我的-个性装扮中查看。</p>
            </div>
          </Scrollbar>
        </div>
      </FirstModal>
    );
  }
}

export default withRouter(FirstRechargeSuccess, { withRef: true });
